const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://tezdauz.uz';

export function getApiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}

export { API_BASE_URL };
